import { ReactElement, useContext } from "react"

import { NON_SYS_ADMIN_STEPS } from "../../../../../constants/ttr/registerDevice"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { AmendDeviceContext } from "../../providers/baseProviders/amendDeviceProvider"

/**
 * Component for displaying the current page on the Amend Device form,
 * should only be used in the NewDeviceVersionContext Provider
 */
const AmendDeviceProgressStepper = (): ReactElement => {
    const { currentIndex } = useContext(AmendDeviceContext)

    return (
        <AppStepper
            currentStepIndex={currentIndex}
            stepLabels={NON_SYS_ADMIN_STEPS}
        />
    )
}

export default AmendDeviceProgressStepper
